// ⚠️ 레거시 — /subscribe 페이지 본문. 그 페이지 외에 쓰이는 곳이 없고 진입점도 없다.
// 구독 신청·결제 흐름(postMembershipSubscribe)의 유일한 구현이라, 신규 구독 결제 경로 설계 시
// 참고 자료로 남겨둔다. MUI + styled-components 기반이므로 재사용이 아니라 재작성 대상.
import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  width: 100%;\n  padding: 40px 0;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  max-width: 600px;\n  margin: 0 auto;\n\n  @media (max-width: 1200px) {\n  }\n  @media (max-width: 768px) {\n    width: 100%;\n    /* margin: 40px 0; */\n    padding: 0 16px;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _tagged_template_literal([
        "\n  width: 100%;\n  display: flex;\n  gap: 8px;\n  padding: 0 28px 20px 28px;\n\n  button {\n    width: 100%;\n  }\n\n  @media (max-width: 768px) {\n    padding: 20px 28px;\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _tagged_template_literal([
        "\n  color: ",
        ";\n  font-weight: 600;\n\n  :hover,\n  :active {\n    color: ",
        " !important;\n    background-color: transparent !important;\n  }\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = _tagged_template_literal([
        "\n  width: 100%;\n  display: flex;\n  gap: 8px;\n\n  justify-content: end;\n\n  button {\n    padding: 12px 20px;\n    margin-top: 28px;\n  }\n\n  @media (max-width: 768px) {\n    button {\n      width: 100%;\n    }\n  }\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BooksWrapper } from "@/components/Books/Order";
import { PaymentButtonContainer } from "@/components/Books/Order/BooksOrder";
import { HorizontalStack, Stack, TitleAndAround, Total } from "@/components/Books/Order/BooksOrderProductItem";
import Icon from "@/components/icon/Icon";
import { ArrowRight, Sizes } from "@/components/icon/IconList";
import PayErrorDialog from "@/components/modal/PayErrorDialog";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { priceFormatter } from "@/lib/utils";
import { MYPAGE_PASSES, PASSES_LANDING } from "@/settings/constant";
import { Button, ConfirmDialog } from "@bookips/solvook-ui-library";
import { Typography } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { useRouter } from "next/router";
import { useCallback, useEffect, useMemo, useState } from "react";
import { postMembershipSubscribe } from "src/api/membership";
import FilledButton from "@/components/common/Button/FilledButton";
import styled, { useTheme } from "styled-components";
import { SubscribeDialog } from "./SubscribeDialog";
import useCheckMyPass from "./useCheckMyPass";
import usePassStore from "src/store/pass";
import { OrderCardContainer } from "../OrderComponents/PaymentCard";
import Notice from "./SubscribeNotice";
const SubscribeToPass = ()=>{
    const router = useRouter();
    const theme = useTheme();
    const [openModal, setOpenModal] = useState(false);
    const [errorCode, setErrorCode] = useState({
        code: 200,
        message: ""
    });
    const { redirectPath , setRedirectPath  } = usePassStore((state)=>({
            redirectPath: state.redirectPath,
            setRedirectPath: state.setRedirectPath
        }));
    const subscribeMutation = useMutation(postMembershipSubscribe);
    const { id: subscribePassId , errorCode: membershipCheck , subscribePass , isError , errorMessages  } = useCheckMyPass();
    const passInformation = useMemo(()=>{
        if (!subscribePass || Object.values(subscribePass).length === 0) return null;
        return subscribePass;
    }, [
        subscribePass
    ]);
    const handleSubscribeClick = useCallback(async ()=>{
        if (!subscribePassId) return;
        try {
            const response = await subscribeMutation.mutateAsync({
                membershipProductId: Number(subscribePassId),
                returnUrl: redirectPath ? redirectPath : process.env.NEXT_PUBLIC_APP_ENDPOINT + MYPAGE_PASSES
            });
            response.payUrl && window.open(response.payUrl, "_self");
            setRedirectPath("");
        } catch (error) {
            const { status  } = error.response;
            ;
            if (status === 404) {
                setErrorCode({
                    message: "정기구독 상품을 확인해주세요.",
                    code: 404
                });
            }
            if (status === 409) {
                setErrorCode({
                    message: "다시 시도해주세요.",
                    code: 409
                });
            }
            if (status === 422) {
                setErrorCode({
                    code: 422
                });
            }
        }
    }, [
        subscribePassId
    ]);
    // useEffect(() => {
    // 	if (checkErrorCode.code === 400) {
    // 		setErrorCode({ message: checkErrorCode.message, code: checkErrorCode.code })
    // 	}
    // }, [checkErrorCode.code])
    useEffect(()=>{
        if (!subscribePassId || isError) {
            router.push(PASSES_LANDING);
        }
    }, [
        subscribePassId,
        isError
    ]);
    useEffect(()=>{
        if (subscribePass) {
            mixpanelEvent("Purchased Page Viewed", {
                "Product Categories": subscribePass.category,
                "Product ID": subscribePass.id,
                "Product Title": subscribePass.title,
                "Product Price": subscribePass.price
            });
        }
    }, [
        subscribePass
    ]);
    var _subscribePass_title, _priceFormatter, _priceFormatter1;
    return /*#__PURE__*/ _jsxs(Container, {
        children: [
            /*#__PURE__*/ _jsx(SubscribeDialog, {
                open: openModal,
                onClose: ()=>setOpenModal(false),
                contentInfo: passInformation,
                footer: /*#__PURE__*/ _jsxs(ButtonBox, {
                    children: [
                        /*#__PURE__*/ _jsx(Button, {
                            variant: "strokeSecondary",
                            onClick: ()=>{
                                window.open("https://solvookguide.oopy.io/78b924d5-140f-4475-bd9b-d13d99bedb2b", "_blank");
                            },
                            children: "이용방법 보기"
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            variant: "solid",
                            onClick: ()=>setOpenModal(false),
                            children: "확인"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs(StackBox, {
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "semibold24",
                        children: "정기결제 신청"
                    }),
                    /*#__PURE__*/ _jsxs(Box, {
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "regular16",
                                children: "상품 정보"
                            }),
                            /*#__PURE__*/ _jsx(OrderCardContainer, {
                                children: /*#__PURE__*/ _jsxs(Stack, {
                                    children: [
                                        /*#__PURE__*/ _jsx(HorizontalStack, {
                                            children: /*#__PURE__*/ _jsx(Stack, {
                                                children: /*#__PURE__*/ _jsx(HorizontalStack, {
                                                    children: /*#__PURE__*/ _jsx(TitleAndAround, {
                                                        children: /*#__PURE__*/ _jsx("dt", {
                                                            children: /*#__PURE__*/ _jsx(Typography, {
                                                                variant: "semibold16",
                                                                children: (_subscribePass_title = subscribePass === null || subscribePass === void 0 ? void 0 : subscribePass.title) !== null && _subscribePass_title !== void 0 ? _subscribePass_title : ""
                                                            })
                                                        })
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ _jsxs(Total, {
                                            children: [
                                                /*#__PURE__*/ _jsx("dt", {
                                                    children: "월 정기결제 금액"
                                                }),
                                                /*#__PURE__*/ _jsxs("dd", {
                                                    className: "amount",
                                                    children: [
                                                        (_priceFormatter = priceFormatter(subscribePass === null || subscribePass === void 0 ? void 0 : subscribePass.price)) !== null && _priceFormatter !== void 0 ? _priceFormatter : "",
                                                        "원"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsxs(PackageDetailButton, {
                                type: "text",
                                onClick: ()=>{
                                    setOpenModal(true);
                                    mixpanelEvent("Product Detail Button Clicked", {
                                        "Product Category": subscribePass === null || subscribePass === void 0 ? void 0 : subscribePass.category,
                                        "Product ID": subscribePass === null || subscribePass === void 0 ? void 0 : subscribePass.id,
                                        "Product Title": subscribePass === null || subscribePass === void 0 ? void 0 : subscribePass.title,
                                        "Product Price": subscribePass === null || subscribePass === void 0 ? void 0 : subscribePass.price,
                                        "Button UI": "Arrow"
                                    });
                                },
                                children: [
                                    "구독권 자세히보기",
                                    /*#__PURE__*/ _jsx(Icon, {
                                        icon: ArrowRight,
                                        color: theme.new.colors.sol_indigo_500,
                                        size: Sizes.small
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Box, {
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "regular16",
                                children: "결제 정보"
                            }),
                            /*#__PURE__*/ _jsxs(Card, {
                                children: [
                                    /*#__PURE__*/ _jsx(Notice, {
                                        title: "정기결제 유의사항",
                                        caution: caution
                                    }),
                                    /*#__PURE__*/ _jsxs(Total, {
                                        children: [
                                            /*#__PURE__*/ _jsx("dt", {
                                                children: "월 정기결제 금액"
                                            }),
                                            /*#__PURE__*/ _jsx("dd", {
                                                className: "amount",
                                                children: /*#__PURE__*/ _jsxs(Typography, {
                                                    variant: "bold16",
                                                    sx: {
                                                        color: theme.new.colors.sol_indigo_500
                                                    },
                                                    children: [
                                                        (_priceFormatter1 = priceFormatter(subscribePass === null || subscribePass === void 0 ? void 0 : subscribePass.price)) !== null && _priceFormatter1 !== void 0 ? _priceFormatter1 : "",
                                                        "원"
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs(PaymentButtonContainer, {
                                        children: [
                                            /*#__PURE__*/ _jsx(Button, {
                                                variant: "solid",
                                                label: "구독 결제하기",
                                                sx: {
                                                    fontSize: "16px",
                                                    padding: "16px 24px"
                                                },
                                                onClick: ()=>handleSubscribeClick()
                                            }),
                                            /*#__PURE__*/ _jsx(Typography, {
                                                variant: "regular14",
                                                sx: {
                                                    color: theme.new.colors.sol_gray_500,
                                                    textAlign: "center"
                                                },
                                                children: "결제 시 유의사항 및 정보를 확인하였으며 동의한 것으로 간주합니다."
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            (errorCode.code === 404 || errorCode.code === 409) && /*#__PURE__*/ _jsx(ConfirmDialog, {
                severity: "caution",
                open: !!errorCode.message,
                onClose: ()=>{},
                title: errorCode.message,
                footer: /*#__PURE__*/ _jsx(OneButtonBox, {
                    children: /*#__PURE__*/ _jsx(Button, {
                        variant: "solid",
                        label: "확인",
                        onClick: ()=>setErrorCode({
                                message: "",
                                code: 200
                            })
                    })
                })
            }),
            membershipCheck !== 200 && /*#__PURE__*/ _jsx(ConfirmDialog, {
                open: true,
                ...errorMessages[membershipCheck]
            }),
            errorCode.code === 422 && /*#__PURE__*/ _jsx(PayErrorDialog, {
                open: true,
                onClose: ()=>setErrorCode({
                        message: "",
                        code: 200
                    })
            })
        ]
    });
};
const Container = styled(BooksWrapper).withConfig({
    componentId: "sc-781b0a56-0"
})(_templateObject());
const StackBox = styled.div.withConfig({
    componentId: "sc-781b0a56-1"
})(_templateObject1());
const Box = styled.div.withConfig({
    componentId: "sc-781b0a56-2"
})(_templateObject2());
const Card = styled(OrderCardContainer).withConfig({
    componentId: "sc-781b0a56-3"
})(_templateObject3());
const ButtonBox = styled.div.withConfig({
    componentId: "sc-781b0a56-4"
})(_templateObject4());
// 구 pages/passes/order.tsx 에서 이동 — 해당 페이지 삭제로 유일한 사용처인 이곳에 인라인
const PackageDetailButton = styled(FilledButton).withConfig({
    componentId: "sc-781b0a56-5"
})(_templateObject5(), (props)=>props.theme.new.colors.sol_indigo_500, (props)=>props.theme.new.colors.sol_indigo_600);
const OneButtonBox = styled.div.withConfig({
    componentId: "sc-781b0a56-6"
})(_templateObject6());
export default SubscribeToPass;
const caution = [
    "약정형 정기 구독 상품은 열람 및 편집 등의 콘텐츠 이용 이력이 없는 경우 결제일 기준 7일 이내에 고객센터를 통해 구독 철회할 수 있으며 전액 환불됩니다.",
    "약정형 정기 구독 결제는 구독 첫 달의 결제일을 기준으로 매달 동일한 날짜에 자동 결제되며, 결제월에 해당 일자가 없는 경우 말일에 결제가 이루어집니다.",
    "구독을 해지하고자 하는 경우 고객센터를 통해 구독 해지 신청이 가능합니다. 이미 구독 기간이 만료된 정기 구독 상품에 대한 환불이나 구독 해지는 불가능합니다.",
    "구독 해지를 신청한 달의 결제일 이전까지는 정기 구독 상품을 이용할 수 있으며, 결제일이 지나면 정기 구독 상품 및 정기 구독 상품을 통해 이용한 콘텐츠를 이용할 수 없습니다.",
    "결제 수단의 정지/한도초과/잔액 부족 등의 사유로 결제가 성공하지 않는 경우, 자동으로 구독이 해지 처리됩니다.",
    "약정된 기간이 지나지 않은 시점에서 중도 해지를 요청하는 경우 약정 미준수에 따른 위약금이 발생할 수 있으며 해당 위약금은 해지 시 반환 금액에서 제외됩니다.",
    "자료저작자 및 저작권자와의 계약 또는 요청에 따라 일부 자료 콘텐츠의 이용 서비스가 제한될 수 있습니다.",
    "모든 결제 금액에는 부가세(VAT)가 포함되어 있습니다."
];
